var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartiallyPaidInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9780",
    "data-name": "Group 9780",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.365,
    height: 48.377,
    viewBox: "0 0 48.365 48.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3953",
    "data-name": "Rectangle 3953",
    width: 48.365,
    height: 48.376,
    fill: "#2a4c7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9741",
    "data-name": "Group 9741",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12134",
    "data-name": "Path 12134",
    d: "M41.292,7.085A24.188,24.188,0,1,0,7.085,41.292,24.188,24.188,0,0,0,41.292,7.085M37.658,37.423l-26.7-26.7a18.883,18.883,0,0,1,26.7,26.7",
    transform: "translate(0 0)",
    fill: "#2a4c7d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiallyPaidInvoices);
export default __webpack_public_path__ + "static/media/PartiallyPaidInvoices.349dc14f1db81f41510f4c2dfacb5a4d.svg";
export { ForwardRef as ReactComponent };